import { CssCustomCodeIcon, JsCustomCodeIcon } from '@carboncopyco/icons';
import type {
  FindReplaceRule,
  ISnippetRule,
  SnippetType,
} from '@carboncopyco/types';
import type { IFindAndReplaceRuleType } from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState } from 'react';
import {
  type RuleSelectionOption,
  RuleSelectionPopover,
} from '../RuleSelectionPopover';
import { AddRuleButton } from '../RulesManager';

export interface AddCustomCodeButtonProps {
  rules: FindReplaceRule[];
  onSelect: (ruleType: IFindAndReplaceRuleType) => void;
}

const ruleOptions: RuleSelectionOption<SnippetType>[] = [
  {
    value: 'js',
    icon: <JsCustomCodeIcon />,
    label: 'JavaScript',
  },
  {
    value: 'css',
    icon: <CssCustomCodeIcon />,
    label: 'CSS',
  },
];

export interface AddCustomCodeButtonnProps {
  onSelect: (SnippetType: SnippetType) => void;
  snippets: ISnippetRule[];
}

export const AddCustomCodeButton = ({
  onSelect,
  snippets,
}: AddCustomCodeButtonnProps) => {
  const { editorRulesAndVarsLimit } = useFlags();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const reachedLimit = snippets.length >= editorRulesAndVarsLimit;

  return (
    <RuleSelectionPopover
      open={popoverOpen}
      onOpenChange={() => {
        setPopoverOpen(!popoverOpen);
      }}
      triggerElement={
        <AddRuleButton
          onClick={() => setPopoverOpen(true)}
          disabled={reachedLimit}
          tooltipMessage={
            reachedLimit &&
            `You reached the limit of ${editorRulesAndVarsLimit} snippets`
          }
        />
      }
      options={ruleOptions}
      onSelect={(type) => {
        onSelect(type);
        setPopoverOpen(false);
      }}
    />
  );
};
